import { questionApi } from '@/lib/api/questionnaireApi';
import { handleDeleteError } from '@/lib/queryErrorHandler';
import { QuestionProps } from '@/types/questionnaire';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useDeleteQuestion({
  question,
  onClose,
  onSuccess,
}: {
  question: QuestionProps;
  onClose: () => void;
  onSuccess?: () => void;
}) {
  const queryClient = useQueryClient();
  const deleteQuestionMutation = useMutation({
    mutationFn: () => questionApi.delete(question.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['section', question.questionnaire_section_id],
      });
      toast.success('Question deleted successfully!');
      onSuccess?.();
      onClose();
    },
    onError: (error: any) => handleDeleteError(error, 'question'),
  });
  return {
    deleteQuestionMutation,
  };
}
